import React, { useState } from "react";
import "./index.css";

const TextArea = (props) => {
  const [text, setText] = useState("");
  const changeUpCase = () => {
    let upText = text.toUpperCase();
    setText(upText);
    props.showAlert("Converted Into Upper Case", "Success");
  };

  // let array = [1, 2, 3, 4, 5, 6, 7, 8, 0];

  // let result1 = array.map((element) => element);
  // console.log(result1);
  // let result = array.filter((element) => {
  //   return element;
  // });
  // console.log(result);

  const changeLowCase = () => {
    let lowText = text.toLowerCase();
    setText(lowText);
    props.showAlert("Converted Into Lower Case", "Success");
  };

  const clearText = () => {
    let lowText = "";
    setText(lowText);
    props.showAlert("Text Is Cleared", "Success");
  };

  const copyText = () => {
    navigator.clipboard.writeText(text);

    props.showAlert("Text Is Copied To Clipboard", "Success");
  };

  const clearExSpaces = () => {
    let removeSpace = text.split(/[ ] + /);
    setText(removeSpace.join(" "));
    props.showAlert("Extra Spaces Is Removed", "Success");
  };

  const pasteText = () => {
    let myBox = document.getElementById("myBox");

    myBox.select();

    props.showAlert("Your Text Is Pasted", "Success");
  };

  const onChangeValue = (para) => {
    setText(para.target.value);
  };

  return (
    <>
      <div className="container">
        <div className="textAreaContainer">
          <div className="textArea">
            <h1
              className={`${props.mode}`}
              style={{ background: "transparent" }}
            >
              Enter Text Below To Customize
            </h1>
            <div className="textTab">
              <textarea
                id="myBox"
                rows="3"
                value={text}
                onChange={onChangeValue}
                className="yt"
                style={{
                  background: props.mode === "dark" ? "#2F2E33" : "white",
                  color: props.mode === "dark" ? "white" : "black",
                  border:
                    props.mode === "dark"
                      ? "1px solid white"
                      : "1px solid #000",
                }}
              ></textarea>
            </div>
            <div className="buttons">
              <button
                disabled={text.length === 0}
                className="btn"
                onClick={changeUpCase}
              >
                UPPERCASE
              </button>

              <button
                disabled={text.length === 0}
                className="btn"
                onClick={changeLowCase}
              >
                LOWERCASE
              </button>

              <button
                disabled={text.length === 0}
                className="btn"
                onClick={clearText}
              >
                CLEAR
              </button>

              <button
                disabled={text.length === 0}
                className="btn"
                onClick={copyText}
              >
                COPY TEXT
              </button>

              <button
                disabled={text.length === 0}
                className="btn"
                onClick={clearExSpaces}
              >
                CLEAR SPACES
              </button>
              <button
                disabled={text.length === 0}
                className="btn"
                onClick={pasteText}
              >
                PASTE
              </button>
            </div>
          </div>
        </div>
        <div className="textSummaryContainer">
          <div className="textSummary">
            <h1
              className={`${props.mode}`}
              style={{ background: "transparent" }}
            >
              Your Text Summary
            </h1>
            <p
              className={`${props.mode}`}
              style={{ background: "transparent" }}
            >
              {
                text.split(/\s+/).filter((element) => {
                  return element.length !== 0;
                }).length
              }{" "}
              Words and {text.length} Characters
            </p>
            <p
              className={`${props.mode}`}
              style={{ background: "transparent" }}
            >
              {0.008 *
                text.split(" ").filter((element) => {
                  return element.length !== 0;
                }).length}{" "}
              Minutes To Read
            </p>
          </div>
          <div
            className={`preview ${props.mode}`}
            style={{ background: "transparent" }}
          >
            <h2
              className={`${props.mode}`}
              style={{ background: "transparent" }}
            >
              Preview
            </h2>
            <p>
              {text.length > 0 ? text : "Nothing To Preview!"}
              <br></br>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default TextArea;
